import { EmpathyResult, Mapper } from '@empathy/search-adapter';
import { Result } from '@empathy/search-types';
import { injectable } from 'inversify';

@injectable()
export class GoccoResultMapper implements Mapper<EmpathyGoccoResult, Result> {

  map(rawResult: EmpathyGoccoResult, result: Result): Result {
    try {
      const value = Number.parseFloat(rawResult.salePrice);
      const originalValue = Number.parseFloat(rawResult.price);
      return Object.assign(result, {
        addToCartId: rawResult.id,
        images: [rawResult.imageUrl],
        price: {
          value: value ? value : originalValue,
          originalValue: value ? originalValue : null,
          hasDiscount: value < originalValue && value !== 0
        },
        sizes: rawResult.size
      });
    } catch (e) {
      console.error(e);
    }
  }
}

export interface EmpathyGoccoResult extends EmpathyResult {
  price: string;
  salePrice: string;
  size: string;
  imageUrl: string;

}
